import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  DeleteButton,
  useRedirect,
  useNotify,
} from "react-admin";
import { Box, Typography } from "@mui/material";

const AdminEditToolbar = (props: any) => (
  <Toolbar {...props} sx={{ display: "flex", justifyContent: "space-between" }}>
    <SaveButton />
    <DeleteButton
      redirect="/admins"
      mutationMode="pessimistic"
      confirmTitle="Remove admin"
      confirmContent="Are you sure you want to revoke this person's admin access?"
    />
  </Toolbar>
);

const AdminEdit: React.FC = () => {
  const redirect = useRedirect();
  const notify = useNotify();

  // Email is the document id and cannot be changed in place — only the
  // descriptive fields are editable here.
  const transform = (data: any) => ({
    id: data.id,
    email: data.email,
    displayName: data.displayName || "",
    note: data.note || "",
  });

  const onSuccess = () => {
    notify("adminsPage.updateSuccess", { type: "success" });
    redirect("/admins");
  };

  const onError = () => {
    notify("adminsPage.updateError", { type: "error" });
  };

  return (
    <Edit
      resource="admins"
      transform={transform}
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess, onError }}
    >
      <SimpleForm toolbar={<AdminEditToolbar />}>
        <Box mb={2}>
          <Typography variant="body2" color="textSecondary">
            To change an email address, remove this admin and add a new one — the
            email is the unique identifier and can't be edited in place.
          </Typography>
        </Box>
        <TextInput source="email" label="Email" fullWidth disabled />
        <TextInput source="displayName" label="Name" fullWidth />
        <TextInput
          source="note"
          label="Note"
          fullWidth
          multiline
          rows={2}
        />
      </SimpleForm>
    </Edit>
  );
};

export default AdminEdit;
